type DimensionValue = {
  dimension: string;
  ok: number;
  inError: number;
  mia: number;
  lowDelivery: number;
  deactivated: number;
};

export type Dimension = {
  environment: DimensionValue[];
  publisher: DimensionValue[];
  formatSize: DimensionValue[];
  resolution: DimensionValue[];
};

export const aggregatedStatuses: Dimension = {
  environment: [
    {
      dimension: 'env1',
      ok: 1,
      lowDelivery: 0,
      inError: 0,
      mia: 0,
      deactivated: 0,
    },
  ],
  publisher: [
    {
      dimension: 'pub1',
      ok: 1,
      lowDelivery: 0,
      inError: 0,
      mia: 0,
      deactivated: 0,
    },
  ],
  formatSize: [
    {
      dimension: 'format1',
      ok: 1,
      lowDelivery: 0,
      inError: 0,
      mia: 0,
      deactivated: 0,
    },
  ],
  resolution: [
    {
      dimension: 'res1',
      ok: 1,
      lowDelivery: 0,
      inError: 0,
      mia: 0,
      deactivated: 0,
    },
  ],
};
